module.exports = __webpack_public_path__ + "img/explain_rectangle_white.9eca9d07.svg";